module.exports = "/static/media/laptop.c8368546.png";